/**
 * REQ-104: map layer registry. Renee's "toggle layers one at a time or all together" control can
 * loop over MAP_LAYERS; MapQuickControls is the first consumer.
 *
 * kind 'venueFilter': the button is a shortcut for one filter value (same state as the drawer and
 *                     the Venue Criteria rail, so all three always agree).
 * kind 'geojson':     a separate pin layer (Radio, phase B). Hidden until its data and layer ship.
 */
export const MAP_LAYERS = [
  {
    id: 'video',
    label: 'Video',
    hint: 'Video capable venues: projector or screen, livestream, or recording',
    icon: { set: 'MaterialCommunityIcons', name: 'camcorder' },
    kind: 'venueFilter',
    filter: { group: 'features', value: 'hasVideo' },
  },
  {
    id: 'radio',
    label: 'Radio',
    hint: 'Radio stations',
    icon: { set: 'MaterialCommunityIcons', name: 'radio-tower' },
    kind: 'geojson',
    url: null, // phase B: baked/layers/radio.geojson
    hidden: true,
  },
];

export function visibleMapLayers(layers = MAP_LAYERS) {
  return layers.filter((layer) => !layer.hidden);
}

/** Is a venueFilter layer switched on in this filter state? */
export function isFilterLayerActive(layer, filters) {
  if (!layer || layer.kind !== 'venueFilter' || !layer.filter) return false;
  const values = filters?.[layer.filter.group];
  return Array.isArray(values) && values.includes(layer.filter.value);
}

/** Layer ids that are on, for MapQuickControls' activeLayerIds. */
export function activeMapLayerIds(filters, layers = MAP_LAYERS, extraOn = []) {
  return layers
    .filter((layer) => isFilterLayerActive(layer, filters) || extraOn.includes(layer.id))
    .map((layer) => layer.id);
}
